<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <export-proof-list-filter />
      <export-proof-list-header />
      <export-proof-list-table />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ExportProofList',
  computed: {
  }
}
</script>

<style>

</style>
